import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorTemplate, {
  ErrorTemplateCode,
} from 'web-library/stories/template/ErrorTemplate/ErrorTemplate';
import Link from 'web-library/stories/atom/Link/Link';
import Typography from 'web-library/stories/atom/Typography/Typography';
import ErrorPageTitle from '../../components/errors/ErrorPageTitle';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  subtitle: {
    color: theme.color.text.textSecondary,
     ...typographyTheme(theme, 'h4'),
  },
  link: {
     ...typographyTheme(theme, 'h4'),
  },
}));

const InvalidLink = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ErrorTemplate
      errorCode={'invalidLink' as ErrorTemplateCode}
      title={<ErrorPageTitle label={t('components->>InvalidLink.InvalidLink')} />}
      subtitle={
        <Typography className={classes.subtitle}>
          {t('components->>InvalidLink.LinkIsExpiredInvalid')}{' '}
          <Link className={classes.link} href="/" withUnderline>
            {t('components->>GenericError.BackToHomepage')}
          </Link>
        </Typography>
      }
    />
  );
};

export default InvalidLink;
